<template>
  <v-container class="px-0">
    <v-row no-gutters>
      <v-col>
        <v-row no-gutters>
          <v-col class="d-flex mb-1">
            <v-btn class="mx-2" color="secondary" small @click="refreshSearch"
              ><v-icon>{{ mdiRefresh }}</v-icon
              >{{ $t("label.refresh") }}</v-btn
            >
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-tabs background-color="#009964" center-active dark v-model="tab">
          <v-tab key="selfPickSpotTab1">{{ $t("label.all") }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item key="selfPickSpotTab1">
            <v-card flat>
              <v-row no-gutters class="mt-5" justify="space-around">
                <v-col cols="5">
                  <SelectZone
                    hideDetails
                    v-model="Zone"
                    :label="$t('label.zone')"
                  ></SelectZone>
                </v-col>
                <v-col cols="5">
                  <SelectCity
                    hideDetails
                    v-model="City"
                    :label="$t('label.city')"
                    ref="city"
                    :itemref="Zone.ZoneName"
                  ></SelectCity>
                </v-col>
              </v-row>
              <v-data-table
                :headers="selfPickSpotHeaders"
                :items="selfPickSpots"
                :items-per-page="10"
                item-key="CenterNo"
                class="elevation-1"
                :single-expand="true"
                show-expand
              >
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="mx-0 px-0">
                    <v-card flat class="py-2">
                      <!-- <v-card-text class="py-0 font-weight-bold">{{
                        item.Name
                      }}</v-card-text>
                      <v-card-text class="py-0">{{ item.Address }}</v-card-text> -->
                      <!-- <v-card-text class="py-0">{{
                        item.CityName
                      }}</v-card-text> -->
                      <v-card-text class="py-0 font-weight-bold">{{
                        item.OpeningHours
                      }}</v-card-text>
                      <v-card-text class="py-0 font-weight-bold">{{
                        item.Description
                      }}</v-card-text>
                    </v-card>
                  </td>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    color="secondary"
                    small
                    class="ma-2"
                    @click="showMapArea(item)"
                  >
                    {{ $t("label.map") }}
                    <v-icon right> {{ mdiMapMarker }} </v-icon>
                  </v-btn>
                  <v-btn
                    color="secondary"
                    small
                    class="ma-2"
                    @click="setDefaultPickup(item)"
                  >
                    {{ $t("label.default_pickup_spot") }}
                    <v-icon right> {{ mdiHammerWrench }} </v-icon>
                  </v-btn>
                  <!-- <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        medium
                        class="mr-2"
                        @click="showMapArea(item)"
                      >
                        {{ mdiMapMarker }}
                      </v-icon>
                    </template>
                    <span>{{ $t("label.map") }}</span>
                  </v-tooltip> -->
                  <!-- <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        medium
                        class="mr-2"
                        @click="setDefaultPickup(item)"
                      >
                        {{ mdiHammerWrench }}
                      </v-icon>
                    </template>
                    <span>{{ $t("label.default_pickup_spot") }}</span>
                  </v-tooltip> -->
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-dialog v-model="mapArea" eager width="820px" height="650px">
      <v-card>
        <v-row no-gutters>
          <v-col cols="10">
            <v-card-title>
              {{ mapTitle }}
            </v-card-title>
          </v-col>
          <v-col cols="2" class="my-auto">
            <v-btn
              color="primary"
              small
              icon
              @click="mapArea = false"
              class="float-right mx-6"
              ><v-icon>{{ mdiCloseThick }}</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row no-gutters>
          <v-col>
            <OsmMap :mapMarker="mapMarker" :mapZoom="mapZoom"></OsmMap>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
    >
      <p v-html="snackbarText"></p>
      <template v-slot:action="{ attrs }">
        <v-btn icon @click="snackbar = false" v-bind="attrs">
          <v-icon>{{ mdiClose }}</v-icon>
        </v-btn>
      </template>
    </v-snackbar> -->
    <snackbar-msg
      v-model="snackBarMsg.show"
      :text="snackBarMsg.text"
      :color="snackBarMsg.color"
    ></snackbar-msg>
  </v-container>
</template>

<script>
import {
  mdiRefresh,
  mdiMapMarker,
  mdiHammerWrench,
  mdiCloseThick,
  mdiClose,
} from "@mdi/js";
import i18n from "../lang/lang";
import { GetSelfPickupSpot, SaveMemberDefault } from "@/api/publicServices";
import SelectZone from "@/components/Select/SelectZone.vue";
import SelectCity from "@/components/Select/SelectCity.vue";
import OsmMap from "@/components/OsmMap.vue";

export default {
  metaInfo: {
    title: "自提點",
    titleTemplate: "%s | 控制台 | 青蛙集運",
  },
  data: () => ({
    title: "label.self_pick_spot",
    tab: null,
    selfPickSpots: [],
    Zone: {
      ZoneName: "",
    },
    City: [],
    hideDetails: true,
    mapArea: false,
    mapZoom: 18,
    mapMarker: { lat: 0, lng: 0 },
    mapTitle: "",

    // snackbar: false,
    // snackbarColor: "secondary",
    // snackbarText: "",
    // snackbarTimeout: 10000,

    snackBarMsg: {
      show: false,
      text: "",
      color: "red",
    },

    //svg icons
    mdiRefresh,
    mdiMapMarker,
    mdiHammerWrench,
    mdiCloseThick,
    mdiClose,
  }),
  components: {
    SelectZone: SelectZone,
    SelectCity: SelectCity,
    OsmMap: OsmMap,
  },
  methods: {
    async refreshSearch() {
      try {
        let CityCode = [];
        console.log(this.City);
        if (Array.isArray(this.City)) {
          for (let index in this.City) {
            CityCode.push(this.City[index].CityCode);
          }
        } else if (this.City !== null) {
          CityCode.push(this.City.CityCode);
        }
        const response = await GetSelfPickupSpot({
          CenterType: "ORIGIN_WAREHOUSE",
          ZoneName: this.Zone.ZoneName,
          CityCode: CityCode,
        });
        this.selfPickSpots = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    showMapArea(spot) {
      this.mapZoom = 18;
      let lat = spot.Latitude;
      let lng = spot.Longitude;
      let title = `青蛙集運-${spot.Name}`;
      let type = "1";
      this.mapTitle = spot.Name;
      if (lat == 0 && lng == 0) {
        this.snackBarMsg.text = "Invalid GPS location";
        this.snackBarMsg.color = "red";
        this.snackBarMsg.show = true;
        return;
      }
      Object.assign(this.mapMarker, { lat, lng });
      if (localStorage.getItem("flutter") == "true") {
        try {
          window.flutter_inappwebview.callHandler("flutterMapHandler", {
            lat,
            lng,
            title,
            type,
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        this.mapArea = true;
      }
    },
    async setDefaultPickup(spot) {
      console.log(spot);
      try {
        const memberDefault = {
          MemberDefault: { PickupCenterCode: spot.CenterNo },
        };

        const response = await SaveMemberDefault(memberDefault);
        if (response.data.isSuccess) {
          this.snackBarMsg.text = i18n.t(
            "message.update_default_pickup_success",
            {
              center_name: spot.Name,
            }
          );
          this.snackBarMsg.color = "secondary";
          this.snackBarMsg.show = true;
        } else {
          this.snackBarMsg.text = response.data.Msg;
          this.snackBarMsg.color = "red";
          this.snackBarMsg.show = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    selfPickSpotHeaders() {
      return [
        { text: i18n.t("label.center_no"), value: "CenterNo" },
        { text: i18n.t("label.name"), value: "Name" },
        { text: i18n.t("label.address"), value: "Address" },
        { text: i18n.t("label.actions"), value: "actions", sortable: false },
      ];
    },
  },
  mounted() {
    this.refreshSearch();
  },
  watch: {
    Zone() {
      // if (this.$refs.city) {
      //   this.$refs.city.reset();
      // }
      this.refreshSearch();
    },
    City() {
      this.refreshSearch();
    },
  },
};
</script>

<style scoped>
@media (max-width: 960px) {
  .v-dialog__content {
    justify-content: center;
    align-items: flex-start;
  }
}
</style>
